export type TSkils = {
  name: string;
  skills: string[];
};

export const skills = [
  { name: "Frontend", skills: ["React", "TypeScript", "SCSS", "Bootstrap"] },
  {
    name: "Backend",
    skills: ["Express", "MongoDB", "Mongoose", "Socket.io", "Node.js"],
  },
  {
    name: "Soft Skills",
    skills: [
      "Communication",
      "Timely",
      "Problem-Solver",
      "Attention to Detail",
      "Motivated Learner",
    ],
  },
];
